<template>
  <Transition name="modal-fade">
    <div class="modal-tom" @click="emitClose" :class="{ transparency }" v-if="trigger">
      <div class="modal-content" :class="[`modal-${size}`, customClass]" :style="customStyle" @click.stop="doSomething">
        <header class="modal-header">
          <slot name="header"></slot>
        </header>
        <section class="modal-body scrollbar">
          <slot class="slotbody fs-5" name="body"></slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "Modal",
  props: {
    size: {
      type: String,
      default: "dynamic",
      validator: (value) => ["dynamic", "small", "medium", "actual-medium", "large", "fullscreen"].includes(value),
    },
    customClass: {
      type: String,
      default: "",
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      trigger: false,
      transparency: false,
    };
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    doSomething() {},

    handleEscapeKey(event) {
      if (event.key === "Escape") {
        this.emitClose();
      }
    },
  },
  mounted() {
    this.trigger = true;
    document.addEventListener("keydown", this.handleEscapeKey);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
};
</script>
